import { ReactNode, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import BaseDialog from './BaseDialog';

interface DialogProps {
  backgroundColor?: string;
  children: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  footerHeight?: number;
  showCloseArrow?: boolean;
  shouldShowUser?: boolean;
  setShowDialog?: (show: boolean) => void;
  name: string;
}

const DialogLayout = ({
  setShowDialog,
  children,
  name,
  ...rest
}: DialogProps) => {
  const [shouldShow, setShouldShow] = useState(false);

  const { search } = useLocation();
  const query = useMemo(() => new URLSearchParams(search), [search]);

  useEffect(() => {
    setShouldShow(query.get('dialog') === name);
  }, [query]);

  const handleExit = () => {
    setShowDialog(false);
  };

  return (
    <BaseDialog open={shouldShow} onClose={handleExit} name={name} {...rest}>
      {children}
    </BaseDialog>
  );
};

export default DialogLayout;
